import { Link } from "react-router-dom";
import Wrap from "../wrap";

export default function Cooperate({ bgClass = "primary", buttonTitle = "GET STARTED" }) {

    return (
        <section className={`cooperate-section ${bgClass}`}>
            <Wrap>
                <h2 className="section-title white">Let's Start Something Remarkable Today!</h2>
                <div>
                    <Link className="button-secondary" target="_blank" to='https://apps.pixad.com.tr/auth/sign-up'>{buttonTitle}</Link>
                </div>
            </Wrap>
        </section>
    )
}